<div class="main-box margin-b">
    <div *ngIf="showheader == true" class="header text-center">
        <div class="margin-b">Events</div>


    </div>

    <div *ngIf="showheader == true">


        <div *ngIf="!loading">
            <div *ngFor="let props of arr ">

                <app-card-skelton title='Events'></app-card-skelton>
            </div>
        </div>

        <div>

            <div class="header main-backgroundcolor color margin-b" style="text-align:center;">
                <div>Upcoming Events</div>
            </div>

            <app-no-results-found *ngIf="upcomingEvents?.length == 0 && loading" title='Events' hide='sidebarEvents'>
            </app-no-results-found>
            <div class="card margin-b" *ngFor="let props of upcomingEvents | slice:0:10">


                <div *ngIf="showheader == true" class="image-wrapper" style="height: 130px;">
                    <img class="card-img-top" (click)="navigate(props._id)" [src]="props?.photo|renderImage"
                        (error)="getErrorImage($event)" alt="">
                </div>
                <div class="card-body card-withoutshadow">
                    <h5 class="card-title margin-b cursor" (click)="navigate(props._id)">{{props.eventName}}</h5>

                    <div class="detail-text">
                        <div><i class="far fa-calendar-alt"></i></div>
                        <div class="margin-l text-wrap">{{props.validFrom | date}} to
                            {{props.validTill | date}}</div>
                    </div>

                    <div class="detail-text">
                        <div><i class="fas fa-map-marker-alt"></i></div>
                        <div class="margin-l text-wrap">
                            {{props?.address.streetAddress}} {{props.address.city}},{{props.address.state}},
                            {{props.address.country}}
                        </div>
                    </div>

                </div>
                <div class="card-body">
                    <div class="detail-text" style="float: right;">
                        <div style="display: flex;">
                            <div><i class="fas fa-user-friends"></i></div>
                            <div class="margin-l text-wrap">Followers {{props.followersCount}}</div>
                        </div>
                        <div style="display: flex;">
                            <div class="margin-l"><i class="fas fa-users"></i></div>
                            <div class="margin-l text-wrap">Attendess {{props.attendeeCount}}
                            </div>
                        </div>



                    </div>
                </div>
            </div>
        </div>

        <div>

            <div class="header main-backgroundcolor color margin-b" style="text-align:center;">
                <div>Expired Events</div>
            </div>

            <app-no-results-found *ngIf="expiredEvents?.length == 0 && loading" title='Events' hide='sidebarEvents'>
            </app-no-results-found>
            <div class="card margin-b" *ngFor="let props of expiredEvents | slice:0:4">


                <div *ngIf="showheader == true" class="image-wrapper" style="height: 130px;">
                    <img class="card-img-top" (click)="navigate(props._id)" [src]="props?.photo|renderImage"
                        (error)="getErrorImage($event)" alt="">
                </div>
                <div class="card-body card-withoutshadow">
                    <h5 class="card-title margin-b cursor" (click)="navigate(props._id)">{{props.eventName}}</h5>

                    <div class="detail-text">
                        <div><i class="far fa-calendar-alt"></i></div>
                        <div class="margin-l text-wrap">{{props.validFrom | date}} to
                            {{props.validTill | date}}</div>
                    </div>

                    <div class="detail-text">
                        <div><i class="fas fa-map-marker-alt"></i></div>
                        <div class="margin-l text-wrap">
                            {{props?.address.streetAddress}} {{props.address.city}},{{props.address.state}},
                            {{props.address.country}}
                        </div>
                    </div>

                </div>
                <div class="card-body">
                    <div class="detail-text" style="float: right;">
                        <div style="display: flex;">
                            <div><i class="fas fa-user-friends"></i></div>
                            <div class="margin-l text-wrap">Followers {{props.followersCount}}</div>
                        </div>
                        <div style="display: flex;">
                            <div class="margin-l"><i class="fas fa-users"></i></div>
                            <div class="margin-l text-wrap">Attendess {{props.attendeeCount}}
                            </div>
                        </div>



                    </div>
                </div>
            </div>
        </div>



    </div>

    <div *ngIf="showheader == false" class="card margin-b">
        <div *ngIf="!showheader" class="image-wrapper" style="height: 200px;">
            <img class="card-img-top" [src]="data?.photo|renderImage" alt="" (click)="navigate(data.id)"
                (error)="getErrorImage($event)">
        </div>




        <div class="card-body card-withoutshadow">
            <h5 class="card-title margin-b cursor" (click)="navigate(data.id)"
                [ngClass]="{'font-size':showheader === false}">{{data.name}}</h5>

            <div class="detail-text">
                <div><i class="far fa-calendar-alt" [ngClass]="{'font-size-sm':showheader === false}"></i></div>
                <div class="margin-l text-wrap" [ngClass]="{'font-size-sm':showheader === false}">
                    {{data.startDate | date}} to
                    {{data.endDate | date}}</div>
            </div>

            <div class="detail-text">
                <div><i class="fas fa-map-marker-alt" [ngClass]="{'font-size-sm':showheader === false}"></i></div>
                <div class="margin-l text-wrap" [ngClass]="{'font-size-sm':showheader === false}">
                    {{data?.streetAddress}} {{data.city}},{{data.state}},
                    {{data.country}}
                </div>
            </div>

        </div>
        <div class="card-body">
            <div class="detail-text" style="float: right;">
                <div style="display: flex;">
                    <div><i class="fas fa-user-friends"></i></div>
                    <div class="margin-l text-wrap">Followers {{data.followers}}</div>
                </div>
                <div style="display: flex;">
                    <div class="margin-l"><i class="fas fa-users"></i></div>
                    <div class="margin-l text-wrap">Attendess {{data.attendees}}
                    </div>
                </div>



            </div>
        </div>
    </div>

</div>
